import React from 'react'
import { Typography, Button, useTheme } from '@mui/material'
import { appVersions } from 'constants/featureFlags'
import useFavurTranslation from 'hooks/useFavurTranslation'
import RedesignThemeWrapper from 'redesign/components/atoms/RedesignThemeWrapper'
import { STANDARD_PAGE_HORIZONTAL_PADDING } from 'shared/constants'
import Page from '../Page'
import VersionRequirementDialog from './VersionRequirementDialog'
import { ActionButtonWrapper, ImageContainer } from './styles'
import type { UpdateAppProps } from './types'

const UpdateApp: React.FC<UpdateAppProps> = ({
  meetsRequired,
  FFVersion,
  showDialog,
  redirect,
  dismissDialog,
  children,
}) => {
  const { t } = useFavurTranslation()
  const { palette } = useTheme()

  if (!meetsRequired || FFVersion === appVersions.beforeRequired) {
    return (
      <RedesignThemeWrapper>
        <Page
          paddingX={STANDARD_PAGE_HORIZONTAL_PADDING}
          hideNativeNavigation
          backgroundColor={palette.background.paper}
        >
          <ImageContainer>
            <img src="/assets/images/UpdateApp/UpdateApp.png" alt="Update application" data-testid="update-app-image" />
            <Typography variant="h1" align="center">
              {t('updateApp.title')}
            </Typography>
            <Typography variant="body1" align="center">
              {t('updateApp.text')}
            </Typography>
          </ImageContainer>
          <ActionButtonWrapper>
            <Button variant="contained" color="primary" onClick={redirect}>
              {t('updateApp.button')}
            </Button>
          </ActionButtonWrapper>
        </Page>
      </RedesignThemeWrapper>
    )
  }

  return (
    <>
      {showDialog && (
        <RedesignThemeWrapper>
          <VersionRequirementDialog dismiss={dismissDialog} />
        </RedesignThemeWrapper>
      )}
      {children}
    </>
  )
}

export default UpdateApp
